import { type SiteResponse } from '@on3/api/src';
import {
  On3IconAppleAppStore,
  On3IconGooglePlay,
  On3IconLogoRedSquare,
} from '@on3/icons';
import { FanSiteAvatar } from '@public/components/Image/FanSiteAvatar';
import { useEffect, useState } from 'react';

import styles from './JoinAppPromo.module.scss';

interface AppPromoProps {
  site: SiteResponse;
}

export const JoinAppPromo = ({ site }: AppPromoProps) => {
  const siteOrg = site?.organization;
  const teamName = siteOrg?.knownAs ?? siteOrg?.name ?? 'On3';
  const mascot = siteOrg?.mascot || 'team';
  const isSoftballAmerica = site?.key === 401;
  const isTeam = site?.isTeam && !isSoftballAmerica;
  const imageKey = isTeam ? site.key : 44;

  const [appImageUri, setAppImageUri] = useState(
    `https://on3static.com/static/on3/app/${imageKey}-app.png`,
  );

  useEffect(() => {
    fetch(`https://on3static.com/static/on3/app/${imageKey}-app.png`).then(
      (r) => {
        if (!r.ok) {
          setAppImageUri('https://on3static.com/static/on3/app/44-app.png');
        }
      },
    );
  }, [imageKey]);

  return (
    <section className={styles.block}>
      <div className={styles.container}>
        <div className={styles.details}>
          <div className={styles.appHeader}>
            {isTeam ? (
              <div className={styles.siteAvatar}>
                <FanSiteAvatar
                  asset={site.defaultAvatar}
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <On3IconLogoRedSquare height={50} width={50} />
            )}
            <h2>App</h2>
          </div>
          <p className={styles.content}>
            {`Get the ultimate ${teamName} experience with the On3 App. Trusted news,
        analysis, and real-time alerts for your ${mascot}. Stay informed like never
        before.`}
          </p>
          <div className={styles.appStoreLinks}>
            <a href="https://apps.apple.com/us/app/on3-app/id1629727374">
              <On3IconAppleAppStore height={26} width={26} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.on3">
              <On3IconGooglePlay height={26} width={26} />
            </a>
          </div>
        </div>
        <img
          alt={`${teamName} app`}
          className={styles.siteImage}
          src={appImageUri}
        />
      </div>
    </section>
  );
};
